// ---------------------------------------------------------------------------
// REGRA ÚNICA da faixa "Instalar app".
// Instalar é sugestão, nunca portão: nenhuma tela é bloqueada.
//
// A faixa aparece SÓ em:
//   · /carteira/:codigo   (a pessoa acabou de comprar e vai usar na barraca)
//   · /meus-ingressos
//   · /minhas-inscricoes
//   · /                   (Início — só depois de rolar uma tela)
//
// E NUNCA em: compra (vitrine de fichas, /ingresso, /inscricao, Pix),
// página de evento antes de rolar, painel do organizador (/gerenciar,
// /meus-eventos, /criar), caixa, portaria, barraca, talão do vendedor
// (/meu-talao, /t/:token), /entrar, /recuperar-senha, /nova-senha.
//
// Qualquer tela nova cai em "nunca" — o padrão é não incomodar.
// ---------------------------------------------------------------------------

export type RegraFaixaInstalar = 'nunca' | 'agora' | 'depois-de-rolar';

function limpar(pathname: string): string {
  return pathname.replace(/\/+$/, '') || '/';
}

/** Onde a faixa pode aparecer (e se precisa esperar a pessoa rolar). */
export function regraFaixaInstalar(pathname: string): RegraFaixaInstalar {
  const p = limpar(pathname);

  // Início: só depois de uma tela de rolagem (a primeira tela é do conteúdo).
  if (p === '/') return 'depois-de-rolar';

  // Carteira de fichas: é aqui que a pessoa mostra o QR na barraca.
  if (/^\/carteira\/[^/]+$/.test(p)) return 'agora';

  // Listas de ingressos e de inscrições: telas de consulta, com calma.
  if (p === '/meus-ingressos') return 'agora';
  if (p === '/minhas-inscricoes') return 'agora';

  return 'nunca';
}

// Extrai o token de um endereço /equipe/<token> (aceita também link colado).
export function extrairTokenEquipe(entrada: string): string | null {
  if (!entrada) return null;
  const texto = entrada.trim();
  const viaRota = texto.match(/\/equipe\/([A-Za-z0-9_-]+)/);
  if (viaRota) return viaRota[1];
  // Link colado inteiro (https://...): tenta pela URL.
  try {
    const u = new URL(texto, window.location.origin);
    const m = u.pathname.match(/\/equipe\/([A-Za-z0-9_-]+)/);
    if (m) return m[1];
  } catch {
    // não é URL
  }
  // Talvez seja só o código/token cru.
  if (/^[A-Za-z0-9_-]{6,}$/.test(texto)) return texto;
  return null;
}